import cx from "classnames";
import React from "react";

import { Btn, BtnType } from "@/mk2/components/Btn";
import { Img } from "@/mk2/components/Img";
import { NO_RESULTS_CANCEL_SEARCH } from "@/mk/autogenerated/translations/NoResults.cd0950e2cef508bc56764e845358ad14";
import assetUrl from "@/mk/common/assetUrl";

import styles from "./NoResults.mscss";

interface OwnProps {
    message: React.ReactNode;
    detailMessage?: React.ReactNode;
    className?: string;
    noIcon?: boolean;
    onSearchClear?(event: React.MouseEvent<HTMLButtonElement>);
}

export const NoResults: React.FunctionComponent<OwnProps> = ({
    noIcon,
    message,
    className,
    detailMessage,
    onSearchClear,
}) => (
    <div className={cx(styles.NoResults, className)}>
        {!noIcon && (
            <div className={styles.NoResults__icon}>
                <Img
                    className="image"
                    src={assetUrl + "img/miky/detective-miky@2x.png"}
                    width={210}
                    height={148}
                />
            </div>
        )}
        <div className={styles.NoResults__message}>{message}</div>
        {detailMessage && <div className={styles.NoResults__detail_message}>{detailMessage}</div>}
        {onSearchClear && (
            <div className={styles.NoResults__clear}>
                <Btn type={BtnType.Link} label={NO_RESULTS_CANCEL_SEARCH} onClick={onSearchClear} />
            </div>
        )}
    </div>
);
